import { axiosRequest, METHOD } from '@/api/default.js';
import constants from '@/constants';

// Get email mode (testing vs production)
export async function getEmailMode() {
    const response = await axiosRequest({
        url: constants.URL.EMAIL_MODE,
        method: METHOD.GET,
        requestName: 'GET EMAIL MODE',
        isLoader: false,
    });
    return response;
}

// Get sent test emails
export async function getSentEmails() {
    const response = await axiosRequest({
        url: constants.URL.EMAILS_SENT,
        method: METHOD.GET,
        requestName: 'GET SENT EMAILS',
    });
    return response || [];
}

// Clear all sent test emails
export async function clearSentEmails() {
    const response = await axiosRequest({
        url: constants.URL.EMAILS_SENT,
        method: METHOD.DELETE,
        requestName: 'CLEAR SENT EMAILS',
    });
    return response != null;
}

// Get email statistics
export async function getEmailStats() {
    const response = await axiosRequest({
        url: constants.URL.EMAILS_STATS,
        method: METHOD.GET,
        requestName: 'GET EMAIL STATS',
    });
    return response;
}
